/* SK Page mode: the see-through header picks its text colour from what is behind it.
   Each part of the header (menu button, logo, every link and icon) is checked on its own: over a dark photo it
   turns white (with the white logo), over the white page or the light film it stays dark.
   On normal pages the theme's own white panel and dark text take over while the menu is hovered or open;
   on the landing, and on pages with a film while the film is behind the header, it never does (see ghost()). */
(function () {
  'use strict';

  var header = document.getElementById('site-control');
  if (!header || !document.elementsFromPoint) return;

  // pages with a film (and the landing universe): the header stays see-through even when the mouse is over it
  // or a drop-down is open, so the film is its only background (CSS in sections/sk-page-mode.liquid).
  // 9 Oct 2026: only while a film is actually behind the header. Once a collection has scrolled past its film to the
  // products, the header behaves as on the other collection pages: white with dark text while the mouse is over it
  // or a menu is open. The landing (the universe is the whole page) keeps it throughout.
  var FILMS = '[data-sk-film], [data-sk-zoom], .sks';
  function ghost() {
    var b = document.body;
    if (b.classList.contains('sk-landing')) { b.classList.add('sk-ghost-header'); return; }
    var films = document.querySelectorAll(FILMS);
    var line = header.getBoundingClientRect().bottom;
    var behind = false;
    for (var i = 0; i < films.length; i++) {
      var r = films[i].getBoundingClientRect();
      if (r.height > 0 && r.top < line && r.bottom > 0) { behind = true; break; }
    }
    if (b.classList.contains('sk-ghost-header') !== behind) b.classList.toggle('sk-ghost-header', behind);
  }
  ghost();
  document.addEventListener('shopify:section:load', ghost);
  // a few rectangles read per scroll event (the browser sends at most one per frame)
  window.addEventListener('scroll', ghost, { passive: true });
  window.addEventListener('resize', ghost, { passive: true });
  window.addEventListener('load', ghost);

  // every part of the header decides on its own: the logo, each menu link, each icon, the language switcher
  var PARTS = '.site-control__inner > .menu, .site-control__inner > .logo, .site-control__inline-links .tier-1 > ul > li > a, .nav-right-side > a, .nav-right-side > .weglot-container';
  var GW = 24, GH = 32;                 // brightness grid per photo (the photo squashed to 24 x 32 cells)
  var cache = {};                       // photo url -> { grid } | 'wait' | 'fail'
  var dirty = true, queued = false, lastY = -1;

  function lumRGB(r, g, b) { return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; }

  function parseColor(s) {
    var m = s && s.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }

  /* how visible an element really is (hover images sit on top at opacity 0) */
  function shown(el) {
    var o = 1, n = 0;
    while (el && el !== document.body && n++ < 6) {
      o *= parseFloat(getComputedStyle(el).opacity) || 0;
      if (o < 0.35) return false;
      el = el.parentElement;
    }
    return true;
  }

  function photoGrid(src) {
    var c = cache[src];
    if (c) return c;
    cache[src] = 'wait';
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var cv = document.createElement('canvas');
        cv.width = GW; cv.height = GH;
        var x = cv.getContext('2d');
        x.fillStyle = '#ffffff';              // 9 Oct: see-through parts of a picture sit on the white page, not black
        x.fillRect(0, 0, GW, GH);
        x.drawImage(img, 0, 0, GW, GH);
        var d = x.getImageData(0, 0, GW, GH).data, g = new Float32Array(GW * GH);
        for (var i = 0; i < g.length; i++) g[i] = lumRGB(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]);
        cache[src] = { grid: g };
      } catch (e) { cache[src] = 'fail'; }
      invalidate();
    };
    img.onerror = function () { cache[src] = 'fail'; };
    img.src = src;
    return 'wait';
  }

  /* brightness of a photo at a screen point (null when the point is outside the picture) */
  function imgLum(img, x, y) {
    var src = img.currentSrc || img.src;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!src || !nw || !nh) return null;
    var r = img.getBoundingClientRect();
    var fit = getComputedStyle(img).objectFit;
    var dw = r.width, dh = r.height;
    if (fit === 'contain' || fit === 'cover') {
      var s = fit === 'contain' ? Math.min(r.width / nw, r.height / nh) : Math.max(r.width / nw, r.height / nh);
      dw = nw * s; dh = nh * s;
    }
    var u = (x - (r.left + (r.width - dw) / 2)) / dw;
    var v = (y - (r.top + (r.height - dh) / 2)) / dh;
    if (u < 0 || u > 1 || v < 0 || v > 1) return null;
    var c = photoGrid(src);
    // 9 Oct: a photo still being measured leaves the colour as it is (it used to count as dark, so the logo and links
    // turned white for a moment over every new light photo); one that cannot be read counts as light, so the text
    // stays dark with its strong white outline, which reads on a dark photo too.
    if (c === 'wait') return undefined;
    if (c === 'fail') return 0.7;
    var gx = Math.min(GW - 1, Math.floor(u * GW)), gy = Math.min(GH - 1, Math.floor(v * GH));
    var sum = 0, n = 0;
    for (var j = -1; j <= 1; j++) for (var i = -2; i <= 2; i++) {
      var xx = gx + i, yy = gy + j;
      if (xx < 0 || yy < 0 || xx >= GW || yy >= GH) continue;
      sum += c.grid[yy * GW + xx]; n++;
    }
    return n ? sum / n : null;
  }

  /* 9 Oct 2026: while a product is hovered its first photo fades out and the second one shows. The second photo
     ignores the pointer, so it is not among the elements at a point; it is found here instead (before, the header
     read the page as white there and turned dark over a dark photo). */
  function shownTwin(img, x, y) {
    var box = img.closest('.image, .product-block');
    if (!box) return null;
    var others = box.querySelectorAll('img');
    for (var i = 0; i < others.length; i++) {
      var o = others[i];
      if (o === img || !shown(o)) continue;
      var r = o.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return o;
    }
    return null;
  }

  /* brightness of whatever the page shows at a screen point, under the header */
  function lumAt(x, y) {
    var els = document.elementsFromPoint(x, y);
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      if (el === document.documentElement || el === document.body) break;
      if (header.contains(el)) continue;
      if (el.closest('.skz__card')) return 0.08;        // the dark zoom film (its surround is read as a colour below)
      if (el.closest('.skf')) return 0.85;              // the couture film: light at the top
      if (el.closest('.sks')) return 0.05;              // the universe
      var tag = el.tagName;
      if (tag === 'IMG') {
        var pic = shown(el) ? el : shownTwin(el, x, y);
        if (!pic) continue;
        var l = imgLum(pic, x, y);
        if (l === undefined) return undefined;   // still being measured
        if (l !== null) return l;
        continue;
      }
      if (!shown(el)) continue;
      if (tag === 'VIDEO' || tag === 'CANVAS' || tag === 'IFRAME') return 0.3;
      var cs = getComputedStyle(el);
      var bg = parseColor(cs.backgroundColor);
      if (bg && bg.a > 0.6) return lumRGB(bg.r, bg.g, bg.b);
      if (cs.backgroundImage && cs.backgroundImage.indexOf('url(') > -1) return el.closest('.needs-alt-logo') ? 0.2 : 0.7;
    }
    var pb = parseColor(getComputedStyle(document.body).backgroundColor);
    return pb && pb.a > 0.1 ? lumRGB(pb.r, pb.g, pb.b) : 1;
  }

  var lastRun = 0;
  function update(now) {
    queued = false;
    if (!dirty && window.pageYOffset === lastY) return;
    // at most ~15 checks a second while scrolling; the last one always runs
    if (now - lastRun < 66) { queued = true; setTimeout(function () { requestAnimationFrame(update); }, 66 - (now - lastRun)); return; }
    lastRun = now;
    dirty = false; lastY = window.pageYOffset;
    var parts = header.querySelectorAll(PARTS);
    for (var z = 0; z < parts.length; z++) {
      var zone = parts[z];
      var r = zone.getBoundingClientRect();
      if (r.width < 2 || r.height < 2 || r.bottom < 0) continue;
      var y = Math.max(1, Math.min(window.innerHeight - 1, r.top + r.height / 2));
      var pts = r.width > 150 ? 5 : 3, sum = 0, n = 0;
      for (var i = 0; i < pts; i++) {
        var x = r.left + r.width * (pts === 1 ? 0.5 : 0.1 + 0.8 * i / (pts - 1));
        if (x < 0 || x > window.innerWidth) continue;
        var l = lumAt(x, y);
        if (l === undefined) continue;          // a photo still being measured: decide on the other points, or wait
        sum += l; n++;
      }
      if (!n) continue;
      var lum = sum / n;
      var was = zone.getAttribute('data-sk-tone');
      // a little hysteresis so the colour does not flicker on mid-tones
      var tone = was === 'dark' ? (lum > 0.56 ? 'light' : 'dark') : (lum < 0.46 ? 'dark' : 'light');
      if (tone !== was) zone.setAttribute('data-sk-tone', tone);
    }
  }

  function invalidate() {
    dirty = true;
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', invalidate, { passive: true });
  window.addEventListener('resize', invalidate, { passive: true });
  window.addEventListener('sk:repaint', invalidate);    // a film changed what sits behind the header
  window.addEventListener('load', invalidate);
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') invalidate(); }, true);
  document.addEventListener('transitionend', invalidate, true);
  // pictures fade in after the page shows: look again a few times
  var t = 0, iv = setInterval(function () { invalidate(); if (++t > 12) clearInterval(iv); }, 500);
  invalidate();
})();
